import { render } from "./ExpiryReport.vue?vue&type=template&id=4372336d&scoped=true"
import script from "./ExpiryReport.vue?vue&type=script&lang=js"
export * from "./ExpiryReport.vue?vue&type=script&lang=js"

import "./inventoryReport.css?vue&type=style&index=0&id=4372336d&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4372336d"]])

export default __exports__